import { format, parseISO } from 'date-fns'
import {formatForTimezone} from '../../modules/utilities/dates.js'
import { displayNumber } from '../../modules/utilities/numbers.js'
import { displayReportResults } from '../../modules/ui.js'

const reportTemplate = document.getElementById('tmpl-report-closeoutSummary')

export default class MTCloseoutSummaryReport extends HTMLElement {
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.shadowRoot.appendChild(reportTemplate.content.cloneNode(true))

        this.errorElement = this.shadowRoot.querySelector('#js-error-container')
        this.startDateElement = this.shadowRoot.querySelector('.js-summary-start')
        this.endDateElement = this.shadowRoot.querySelector('.js-summary-end')
        this.printElement = this.shadowRoot.querySelector('#js-print-report')

        this.printElement.addEventListener(
            'click',
            () => {
                this.dispatchEvent(new CustomEvent('printReportEvent'))
            },
            false
        )
    }

    set data(value) {
        const startDate = document.querySelector('#startDate').value
        const endDate = document.querySelector('#endDate').value
        const sd = parseISO(startDate)
        const ed = parseISO(endDate)

        this._data = value

        this._results = value.reportData

        this._summary = {
            receiveHead: value.receiveHead,
            averageInWeight: value.averageInWeight,
            deliveredCattleCostCWT: value.deliveredCattleCostCWT,
            dof: value.dof,
            deadPercent: value.deadPercent,
            gainPerHead: value.gainPerHead,
            adg: value.adg,
            dryMatterConversion: value.dryMatterConversion,
            dryMatterConsumption: value.dryMatterConsumption,
            processingPerHead: value.processingPerHead,
            dryMatterCost: value.dryMatterCost,
            costOfGainCWT: value.costOfGainCWT,
            adc: value.adc,
            shipHead: value.shipHead,
            averageOutWeight: value.averageOutWeight,
            salesCWT: value.salesCWT,
            yieldPercent: value.yieldPercent,
            breakevenCWT: value.breakevenCWT,
            profitTotal: value.profitTotal,
            profitPerHead: value.profitPerHead,
            startDate: new Date(sd),
            endDate: new Date(ed),
        }

        if (this._data.hasError) {
            this.displayError()
        } else {
            this.displaySummary()
            displayReportResults(this, '#js-closeout-results-container')
        }
    }

    displayError() {
        console.log(this._data.errorMessage)
        this.errorElement.innerText = this._data.errorMessage
    }

    summaryTemplate(props) {
        return `
            <div class="summary-card">
                <dt class="summary-label">
                    Received Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.receiveHead,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Average In Weight
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.averageInWeight,
                    0
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Delivered Cattle Cost / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deliveredCattleCostCWT,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Days on Feed
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.dof,
                    0
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dead %
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deadPercent,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Gain / Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.gainPerHead,
                    0
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Average Daily Gain
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.adg,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dry Matter Consumption
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.dryMatterConsumption,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dry Matter Conversion per Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.dryMatterConversion,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Medicine/Processing per Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.processingPerHead,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dry Matter Cost / Ton
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.dryMatterCost,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Cost of Gain / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.costOfGainCWT,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Average Daily Cost
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.adc,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Shipped Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.shipHead,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Average Out Weight
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.averageOutWeight,
                    0
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Sales / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.salesCWT,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Yield %
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.yieldPercent,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Breakeven / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.breakevenCWT,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Total Profit/Loss
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.profitTotal,
                    2
                )}</dd>
            </div>
			<div class="summary-card">
                <dt class="summary-label">
                    Profit/Loss per Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.profitPerHead,
                    2
                )}</dd>
            </div>
        `
    }

    displaySummary() {
        this.startDateElement.innerText = format(
            this._summary.startDate,
            'MM/dd/yyyy'
        )

        this.endDateElement.innerText = format(
            this._summary.endDate,
            'MM/dd/yyyy'
        )

        this.summaryListElement = this.shadowRoot.querySelector(
            '#js-summary-list'
        )

        const summary = this.summaryTemplate(this._summary)

        this.summaryListElement.innerHTML = summary
    }

    locationResultsRow(props) {
        const averageInDate =
            props.AVG_IN_DATE !== null
                ? formatForTimezone(props.AVG_IN_DATE, 'MM/dd/yy')
                : ''

		const shipDate =
            props.SHIP_DATE !== null
                ? formatForTimezone(props.SHIP_DATE, 'MM/dd/yy')
                : ''

        return `
            <tr class="report-data--row">
                <td class="right ownership-percentage">
                    ${displayNumber(props.OWNER_PERCENT * 100, 1)}
                </td>
                <td class="left origin">
                    ${props.ORIGINS ?? ''}
                </td>
                <td class="left sex">
                    ${props.BUYER ?? ''}
                </td>
                <td class="left lot">
                    ${props.LOT ?? ''}
                </td>
                <td class="center average-in-date">
                    ${averageInDate}
                </td>
                <td class="right receive">
                    ${displayNumber(props.RECV_HD_DIST, 2)}
                </td>
                <td class="right in-weight">
                    ${displayNumber(props.PAY_WT, 0)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DEL_CWT, 2)}
                </td>
                <td class="right dof">
                    ${displayNumber(props.DOF, 0)}
                </td>
                <td class="right head">
                    ${displayNumber(props.DEAD_PCT * 100, 2)}
                </td>
                <td class="right current-weight">
                    ${displayNumber(props.GAIN, 0)}
                </td>
                <td class="right head">
                    ${displayNumber(props.ADG, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DMC, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DM_CONS, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.MED_PROC_HD, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DM_COST_PER_TON, 2)}
                </td>
                <td class="right head">
                    ${displayNumber(props.COG, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DAILY_COG, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.SHIP_DIST_HD, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.OUT_WT, 0)}
                </td>
                <td class="right cattle-cwt">
                    ${shipDate}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.SALES_CWT, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.YIELD, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.BE, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.PROFIT_LOSS, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.PROFIT_LOSS_HD, 2)}
                </td>
            </tr>
        `
    }

    calculateLocationTotals(a, l) {
        return {
            receive: a.receive + l.RECV_HD,
            receiveHDDist: a.receiveHDDist + l.RECV_HD_DIST,
            shipped: a.shipped + l.SHIP_DIST_HD,
			dead: a.dead + l.DEAD_HD,
            profitLoss: a.profitLoss + l.PROFIT_LOSS,
			payWt: a.payWt + l.TOTAL_PAY_WT,
			payWtDist: a.payWtDist + l.TOTAL_PAY_WT_DIST,
			delCost: a.delCost + l.DEL_COST,
			hdysOwnPct: a.hdysOwnPct + l.HDYS_OWN_PCT,
			hdysDeadsIn: a.hdysDeadsIn + l.HDYS_DEADS_IN,
			cogExpDist: a.cogExpDist + l.COG_EXPENSES_DIST,
			totalGain: a.totalGain + l.TOTAL_GAIN,
			totalGainLot: a.totalGainLot + l.TOTAL_GAIN_LOT,
			lbDMDist: a.lbDMDist + l.POUNDS_DM_DIST,
			feedCost: a.feedCost + l.FEED_COST_DIST,
			salesProceeds: a.salesProceeds + l.TOTAL_SALES_PROCEEDS,
			salePW: a.salePW + l.SALE_PW,
			saleHd: a.saleHd + l.SALE_HD,
			beCostDist: a.beCostDist + l.BE_COST_DIST,
			salePWDist: a.salePWDist + l.SALE_PW_DIST,
			medCostDist: a.medCostDist + l.MED_COST_DIST,
			yieldHotWt: a.yieldHotWt + l.YIELD_HOT_WT,
			yieldPayWt: a.yieldPayWt + l.YIELD_PAY_WT,
			calcs: {},
        }
    }

    locationTotalsAccumulator() {
        return {
            receive: 0,
			receiveHDDist: 0,
            shipped: 0,
			dead: 0,
            profitLoss: 0,
			payWt: 0,
			payWtDist: 0,
			delCost: 0,
			hdysOwnPct: 0,
			hdysDeadsIn: 0,
			cogExpDist: 0,
			totalGain: 0,
			totalGainLot: 0,
			lbDMDist:0,
			feedCost: 0,
			salesProceeds: 0,
			salePW: 0,
			saleHd: 0,
			beCostDist: 0,
			salePWDist: 0,
			medCostDist: 0,
			yieldHotWt: 0,
			yieldPayWt: 0,
        }
    }
	
	groupResultsTemplate(groupedData) {
		const groupName = groupedData[0]
		const data = groupedData[1]
		const locationID = groupedData[2]
		
		const total = data.reduce(
            this.calculateLocationTotals,
            this.locationTotalsAccumulator()
        )

		total.calcs.cattleCostCWT = total.delCost / total.payWtDist * 100
		total.calcs.gain = total.totalGainLot / total.receive
		total.calcs.inWeight = total.payWt / total.receive
		total.calcs.dof = total.hdysDeadsIn / total.receive
		total.calcs.deadPercent = total.dead / total.receive * 100
		total.calcs.adg = total.totalGainLot / total.hdysDeadsIn
		total.calcs.dailyCost = total.cogExpDist / total.hdysOwnPct
		total.calcs.dmConsumption = total.lbDMDist / total.hdysOwnPct
		total.calcs.dmConversion = total.lbDMDist / total.totalGain
		total.calcs.cog = total.cogExpDist / total.totalGain * 100
		total.calcs.processing = total.medCostDist / total.receiveHDDist
		total.calcs.dmCost = total.feedCost / total.lbDMDist * 2000
		total.calcs.saleCWT = total.salesProceeds / total.salePW * 100
		total.calcs.beCWT = total.beCostDist / total.salePWDist * 100
		total.calcs.outWeight = total.salePW / total.saleHd
		total.calcs.yieldPercent = total.yieldHotWt / total.yieldPayWt * 100
		total.calcs.profitLossHead = total.profitLoss / total.receiveHDDist
		
		let spanCollapsed = "false"
		let spanClass = "collapsed-hidden"
		let headerCollapsed = ""
		
		if(groupName == 'total'){
			spanCollapsed = "true"
			spanClass = "expanded-hidden"
			headerCollapsed = "collapsed-hidden"
		}
		
		return `<span data-collapsible-id="${locationID}-${groupName}" data-collapsed="${spanCollapsed}" class="${spanClass}">
			<h3 class="mt-report-title ${headerCollapsed}">&nbsp;&nbsp;
				<svg data-collapsed="false" id="collapse-${locationID}-${groupName}" class="h-3 w-3 md:h-6 md:w-6" fill="var(--color-action)" viewBox="-150 -350 900 900" height="1.5rem" aria-hidden="true" style="cursor:pointer;">
		              <path name="expand-icon"
		                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
		              <path name="collapse-icon"
		                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" />
	            </svg>
				${groupName}
			</h3>
			<div class="mt-table--container">
                    <table class="js-report--table mt-table">
                <thead class="mt-table--head">
                    <tr>
                        <th scope="col" class="right ownership-percentage collapsed-hidden">
                            <abbr title="Ownership Percentage">Owner%</abbr>
                        </th>
                        <th scope="col" class="left origin collapsed-hidden">
                            Origin
                        </th>
                        <th scope="col" class="left sex collapsed-hidden">
                            Buyer
                        </th>
                        <th scope="col" class="left lot collapsed-hidden">
                            Lot
                        </th>
                        <th scope="col" class="center average-in-date collapsed-hidden">
                            <abbr title="In Date">In Dt</abbr>
                        </th>
                        <th scope="col" class="right receive">
                            Receive
                        </th>
                        <th scope="col" class="right average-in-weight">
                            <abbr title="In Weight">In Wt</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Delivered Cattle Cost / CWT">Cattle / CWT</abbr>
                        </th>
                        <th scope="col" class="right dof">
                            <abbr title="Days on Feed">DOF</abbr>
                        </th>
                        <th scope="col" class="right dead">
                            Dead%
                        </th>   
                        <th scope="col" class="right live">
                            <abbr title="Gain / Head">Gain</abbr>
                        </th>
                        <th scope="col" class="right ship">
                            <abbr title="Average Daily Gain">ADG</abbr>
                        </th>
                        <th scope="col" class="right ship">
                            <abbr title="Dry Matter Conversion">DMC</abbr>
                        </th>
                        <th scope="col" class="right current-weight">
                            <abbr title="Dry Matter Consumption">DM Con</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Medicine/Processing per Head">Med/Proc</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Dry Matter Cost / Ton">DM/Ton</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Cost of Gain / CWT">COG</abbr>
                        </th>
                        <th scope="col" class="right average-daily-cost">
                            <abbr title="Average Daily Cost">Avg Dly Cost</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Shipped Head">Ship Hd</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Out Weight">Out Wt</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt collapsed-hidden">
                            <abbr title="Ship Date">Ship Dt</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            Sale / CWT
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Yield %">Yld%</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Breakeven / CWT">BE</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Profit/Loss">P/L</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Profit/Loss per Head">P/L Hd</abbr>
                        </th>
                    </tr>
                </thead>
                <tbody>
                ${data.map(this.locationResultsRow).join('')}
                </tbody>
                <tfoot>                
                    <tr>
                        <th scope="row" class="total" colspan="5">Total</th>
                        <td class="footer-total receive">${displayNumber(
                            total.receiveHDDist,
                            2
                        )}</td>
                        <td class="footer-total live">${displayNumber(
                            total.calcs.inWeight,
                            0
                        )}</td>
                        <td class="footer-total ship">${displayNumber(
                            total.calcs.cattleCostCWT,
                            2
                        )}</td>
                        <td class="footer-total dead">${displayNumber(
                            total.calcs.dof,
                            0
                        )}</td>
                        <td class="footer-total average-in-weight">${displayNumber(
                            total.calcs.deadPercent,
                            2
                        )}</td>
                        <td class="footer-total average-in-weight">${displayNumber(
                            total.calcs.gain,
                            0
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.adg,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.dmConversion,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.dmConsumption,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.processing,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.dmCost,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.cog,
                            2
                        )}</td>               
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.dailyCost,
                            2
                        )}</td>                
                        <td class="footer-total dof">${displayNumber(
                            total.shipped,
                            2
                        )}</td>                
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.outWeight,
                            0
                        )}</td>
						<td></td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.saleCWT,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.yieldPercent,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.beCWT,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.profitLoss,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.calcs.profitLossHead,
                            2
                        )}</td>
                    </tr>
                </tfoot>
                </table>
                </div>
				</span>
			`
	}

    locationNoResultsTemplate(props) {
        return `
            <div class="mt-well mt-template-indent" data-location-id="${props.locationID}">
                <div class="mt-well--content">
                <h3 class="mt-report-title">${props.locationName}</h3>
                    <p>There are no results for ${props.locationName} during this timeframe.</p>
                </div>
            </div>
            `
    }

	groupBy(arr, property) {
  		return arr.reduce(function(group, x) {
    	if (!group[x[property]]){
				group[x[property]] = []
			}
			group[x[property]].push(x)
			return group
  		}, {})
	}

    locationResultsTemplate(props) {
		let groupedData = this.groupBy(props.data, 'SEX')		
		let groupedDataArr = []		 
		
		Object.keys(groupedData).forEach((key)=>{
			groupedDataArr.push([key, groupedData[key], props.locationID])
		})
		
		groupedDataArr.push(['total', props.data, props.locationID])

        return `
            <div class="mt-well" data-location-id="${props.locationID}" data-collapsible-id="${props.locationID}" data-collapsed="false">
                <div class="mt-well--content">
                    <h3 class="mt-report-title">
						<svg id="collapse-${props.locationID}" data-collapsed="false" class="h-3 w-3 md:h-6 md:w-6" fill="var(--color-action)" viewBox="-150 -350 900 900" height="1.5rem" aria-hidden="true" style="cursor:pointer;">
				            <path name="expand-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
			                <path name="collapse-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" />
			            </svg>${props.locationName}
					</h3>
                    ${groupedDataArr.map(this.groupResultsTemplate, this).join('')}
    			</div>
  			</div>
        `
    }

    connectedCallback() {}

    render() {}
}

customElements.define('mt-cs-report', MTCloseoutSummaryReport)
